module.exports = __webpack_public_path__ + "static/media/2017 Greece.8f7c8cee.jpg";